import {Button, Modal} from "antd";
import React from "react";
import close from "../../../assets/images/close.svg";
import icon from "../../../assets/images/modal-icon-payment-error.svg";
import {ErrorDto} from "../../../core/models/dtos/error.dto";
import {MeDto} from "../../../core/models/dtos/me.dto";
import {Operator} from "../../../core/models/enums/operator";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {Errors} from "../../../core/utilities/errors";
import {UI} from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import "./PaymentErrorModal.scss";

interface IProps {
  me?: MeDto;
  error: ErrorDto;
  callback: (type?: PaymentErrorCallbackType) => void;
}

export enum PaymentErrorCallbackType {
  retry = 'retry',
  payWithCC = 'payWithCC',
  payWithMobile = 'payWithMobile',
}

interface PaymentErrorContentKeys {
  title: string;
  text: string;
  btnRetry?: PaymentErrorBtn;
  btnPayWithCC?: PaymentErrorBtn;
  btnPayWithMobile?: PaymentErrorBtn;
  btnExternalLink?: PaymentErrorBtn;
}

interface PaymentErrorBtn {
  text: string;
  className?: 'secondary';
  link?: string;
}

const PaymentErrorModal = (props: IProps) => {
  
  const getContentKeys = (): PaymentErrorContentKeys => {
    switch (props.error.message) {
      case Errors.errorChargeFailed:
      case Errors.errorHasSavedCard:
      case Errors.errorSendOtpAttemptFailed:
        const isTurkcell = props.me?.operator === Operator.TURKCELL;
        return isTurkcell
          ?
          {
            title: FirebaseService.error_cc_turkcell_title,
            text: FirebaseService.error_cc_turkcell_desc,
            btnRetry: {
              text: FirebaseService.error_cc_turkcell_try_again_button,
            },
            btnPayWithMobile: {
              text: FirebaseService.error_cc_turkcell_mobile_payment_button,
              className: 'secondary',
            }
          }
          :
          {
            title: FirebaseService.error_payment_popup_header,
            text: FirebaseService.error_payment_popup_desc,
            btnRetry: {
              text: FirebaseService.error_payment_popup_button,
            },
          }
      case Errors.errorMobilePaymentNotFound:
        return {
          title: FirebaseService.error_mobile_payment_disabled_title,
          text: FirebaseService.error_mobile_payment_disabled_desc,
          btnExternalLink: {
            text: FirebaseService.error_mobile_payment_disabled_try_again_button,
            link: 'https://dijital.li/D3GXT',
          },
          btnPayWithCC: {
            text: FirebaseService.error_mobile_payment_disabled_cc_button,
            className: 'secondary',
          },
        }
      case Errors.errorMobilePaymentLimit:
        return {
          title: FirebaseService.error_mobile_payment_insufficient_limit_title,
          text: FirebaseService.error_mobile_payment_insufficient_limit_desc,
          btnPayWithCC: {
            text: FirebaseService.error_mobile_payment_insufficient_limit_cc_button
          },
        }
      case Errors.errorMobilePaymentEulaExpired:
        return {
          title: FirebaseService.error_mobile_payment_general_title,
          text: FirebaseService.error_mobile_payment_general_desc,
          btnRetry: {
            text: FirebaseService.error_mobile_payment_general_try_again_button
          },
          btnPayWithCC: {
            text: FirebaseService.error_mobile_payment_general_cc_button,
            className: "secondary",
          },
        }
      default:
        return {
          title: 'Payment Error',
          text: `Invalid message ${props.error.message}`,
        }
    }
  }
  
  const content = getContentKeys();
  
  return (
    <Modal
      className="payment-error-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable
      closeIcon={<img src={close} alt="close" onClick={() => props.callback()}/>}
      footer={false}
      centered
      destroyOnClose
    >
      {
        !!content &&
        <div className="content">
          <img className="icon" src={icon} alt="icon"/>
          <FirebaseKey className="title" firebaseKey={content.title}/>
          <FirebaseKey className="text" firebaseKey={content.text}/>
          {
            content.btnExternalLink &&
            <Button
              className={`app-button ${content.btnExternalLink.className}`}
            >
              <a href={content.btnExternalLink.link} rel="noreferrer noopener">
                <FirebaseKey firebaseKey={content.btnExternalLink.text}/>
              </a>
            </Button>
          }
          {
            content.btnRetry &&
            <Button
              className={`app-button ${content.btnRetry.className}`}
              onClick={() => props.callback(PaymentErrorCallbackType.retry)}
            >
              <FirebaseKey firebaseKey={content.btnRetry.text}/>
            </Button>
          }
          {
            content.btnPayWithCC &&
            <Button
              className={`app-button ${content.btnPayWithCC.className}`}
              onClick={() => props.callback(PaymentErrorCallbackType.payWithCC)}
            >
              <FirebaseKey firebaseKey={content.btnPayWithCC.text}/>
            </Button>
          }
          {
            content.btnPayWithMobile &&
            <Button
              className={`app-button ${content.btnPayWithMobile.className}`}
              onClick={() => props.callback(PaymentErrorCallbackType.payWithMobile)}
            >
              <FirebaseKey firebaseKey={content.btnPayWithMobile.text}/>
            </Button>
          }
        </div>
      }
    </Modal>
  );
}

export default PaymentErrorModal;
